import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import permissionsApi from '@/api/permissionsApi';

export const PERMISSIONS_QUERY_KEY = ['permissions'];

export function useMyPermissions(enabled: boolean = true) {
  return useQuery({
    queryKey: PERMISSIONS_QUERY_KEY,
    queryFn: permissionsApi.getMyPermissions,
    staleTime: 0, // Always refetch - critical for auth check
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes for background use
    retry: 1,
    enabled,
  });
}

export function useAppraisalAccess(appraisalId: string) {
  return useQuery({
    queryKey: [...PERMISSIONS_QUERY_KEY, 'appraisal', appraisalId],
    queryFn: () => permissionsApi.getAppraisalAccess(appraisalId),
    enabled: !!appraisalId,
    staleTime: 2 * 60 * 1000, // 2 minutes - record access may change more frequently
  });
}

export function useJobEndAccess(jobEndId: string) {
  return useQuery({
    queryKey: [...PERMISSIONS_QUERY_KEY, 'job-end', jobEndId],
    queryFn: () => permissionsApi.getJobEndAccess(jobEndId),
    enabled: !!jobEndId,
    staleTime: 2 * 60 * 1000, // 2 minutes - record access may change more frequently
    retry: (failureCount, error) => {
      if (isAxiosError(error) && (error.response?.status === 401 || error.response?.status === 403)) {
        return false;
      }
      return failureCount < 1;
    },
  });
}
